import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Separator } from '@/components/ui/separator';
import { updateTvController, useTvController } from '@/lib/api/tvController';
import { TvController } from '@/lib/schema/tvController';
import { TvControllerForm } from '@/pages/tv-controllers/tvControllerForm';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

function submitTvController(data: TvController) {
  return updateTvController(data.id!, data);
}

export default function UpdateTvControllerPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [data, isLoading] = useTvController(id);

  const mutation = useMutation({
    mutationFn: submitTvController,
    onSuccess: () => {
      navigate('/tv-controllers'); // Redirect to TV controllers list after successful creation
    },
    onError: (error) => {
      console.error('Error creating TV controller:', error);
    },
  });

  const onSubmit = (data: TvController) => {
    mutation.mutate({ ...data, id });
  };

  if (isLoading || !id) {
    return null;
  }

  return (
    <div className="w-full pb-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Update device</h1>
        </div>
      </div>

      <Separator className="my-6" />

      <div className="grid gap-2 mb-4">
        <Label>MAC Address</Label>
        <Input
          autoComplete="off"
          placeholder="Enter controller name"
          disabled={true}
          value={data?.macAddress || '--'}
        />
      </div>

      <TvControllerForm
        tvControllerId={id}
        tvController={data}
        mutation={mutation}
        onSubmit={onSubmit}
      />
    </div>
  );
}
